import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard for permission-gated pages. When the current user lacks `moduleKey`,
 * the page is replaced with a "no access" panel — so even a directly-typed URL is blocked.
 * Admins always pass.
 */
const ModuleRoute = ({ moduleKey, children }) => {
  const { hasModuleAccess, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  if (!hasModuleAccess(moduleKey)) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: '70vh', padding: '2rem' }}>
        <div
          className="d-flex align-items-center justify-content-center mb-3"
          style={{ width: 72, height: 72, borderRadius: 20, background: '#fee2e2', color: '#dc2626' }}
        >
          <FaLock size={30} />
        </div>
        <h4 className="fw-bold text-dark mb-2">Access restricted</h4>
        <p className="text-muted mb-4" style={{ maxWidth: 460 }}>
          You don&apos;t have permission to view this section. Please contact your workspace admin
          if you believe you should have access.
        </p>
        <Link to="/dashboard" className="btn btn-primary">
          Back to Dashboard
        </Link>
      </div>
    );
  }

  return children;
};

export default ModuleRoute;
